import { render, staticRenderFns } from "./Ticketing.vue?vue&type=template&id=18195c1c&scoped=true&"
import script from "./Ticketing.vue?vue&type=script&lang=js&"
export * from "./Ticketing.vue?vue&type=script&lang=js&"
import style0 from "./Ticketing.vue?vue&type=style&index=0&id=18195c1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18195c1c",
  null
  
)

export default component.exports